import { memo } from 'react';
import { Skeleton, theme } from '@frameio/vapor';
import { ImageWrapper } from '../../../../shared/components';
import styles from './DetailSkeleton.module.css';

type DetailSkeletonProps = {
  paddingTop?: number;
};

const DetailSkeleton = memo(({ paddingTop = 0 }: DetailSkeletonProps) => {
  return (
    <div
      className={styles.detailSkeletonContainer}
      style={paddingTop ? { paddingTop } : undefined}
    >
      <div className={styles.detailPreviewContainer}>
        <ImageWrapper borderRadius={8} hasBorder={false}>
          <div className={styles.detailPreviewFrame}>
            <Skeleton
              height="100%"
              style={{ lineHeight: 'normal', borderRadius: theme.radii[8] }}
              width="100%"
            />
          </div>
        </ImageWrapper>
      </div>
      <div className={styles.detailHeaderContainer}>
        <Skeleton height="12px" width="100%" />
        <div className={styles.detailHeaderMetadata}>
          <div className={styles.detailHeaderMetadataItem}>
            <Skeleton height="100%" width="100%" />
          </div>
          <div className={styles.detailHeaderMetadataItem}>
            <Skeleton height="100%" width="100%" />
          </div>
        </div>
      </div>
      <div className={styles.detailRowsContainer}>
        <Skeleton
          height="32px"
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
          width="100%"
        />
        <Skeleton height="32px" style={{ borderRadius: 0 }} width="100%" />
        <Skeleton height="32px" style={{ borderRadius: 0 }} width="100%" />
        <Skeleton
          height="32px"
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
          width="100%"
        />
      </div>
    </div>
  );
});

DetailSkeleton.displayName = 'DetailSkeleton';

export { DetailSkeleton };
